import ko from '@tko/build.knockout';
import _ from 'lodash';

    

    ko.bindingHandlers.domElement = {
        init: function (element) {
            var viewModel = ko.dataFor(element);

            if (!_.isEmpty(viewModel)) {
                viewModel.domElement = element; // make the dom element available in the view model
            }
        }
    };
